import { Typography } from "@material-tailwind/react";
import { BuildingOfficeIcon, TruckIcon } from "@heroicons/react/24/solid";
import { t } from "i18next";
import { TabsNav } from "../../../../components/tabs/TabsNav";
import AdminOdooCustomersTab from "./tabs/customers/AdminOdooCustomersTab";
import AdminOdooWorkordersTab from "./tabs/workorders/AdminOdooWorkordersTab";

export default function AdminOdoo() {
  const tabs = [
    {
      label: t("admin:odoo.tabs.customers", "Clients"),
      icon: BuildingOfficeIcon,
      value: "customers",
      Component: AdminOdooCustomersTab
    },
    {
      label: t("admin:odoo.tabs.workorders", "Interventions"),
      icon: TruckIcon,
      value: "workorders",
      Component: AdminOdooWorkordersTab
    }
  ];

  return (
    <div className="views-padded">
      <div className="my-4">
        <div className="flex flex-col gap-1">
          <Typography variant="h4">{t("admin:odoo.title", "Intégration Odoo")}</Typography>
          <Typography variant="small" className="text-gray-600">
            {t("admin:odoo.subtitle", "Gérez les correspondances des champs techniques synchronisés entre EasyTech et Odoo.")}
          </Typography>
        </div>
      </div>

      <TabsNav<any> defaultTab="customers" tabs={tabs} data={{}} />
    </div>
  );
}
